import React, { useState } from 'react';
import { Input, Radio, RadioGroup, Stack, FormControl, FormLabel, Box, Divider, Textarea } from "@chakra-ui/react";1458
import SubmitButton from "./SubmitButton";
import { useNavigate } from 'react-router-dom';
import { switchAndCreateBrowserWallet } from "../usecases/repositories/common";

interface Props {
  walletAddress: string;
  setWalletAddress: React.Dispatch<React.SetStateAction<string>>;
  purpose: string;
  setPurpose: React.Dispatch<React.SetStateAction<string>>;
  informationSource: string;
  setInformationSource: React.Dispatch<React.SetStateAction<string>>;
  satisfaction: string;
  setSatisfaction: React.Dispatch<React.SetStateAction<string>>;
  feedback: string;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
}

const QuestionForm: React.FC<Props> = ({ walletAddress, setWalletAddress, purpose, setPurpose, informationSource, setInformationSource, satisfaction, setSatisfaction, feedback, setFeedback }) => {
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    setSubmitted(true);
  };

  const handleIframeLoad = () => {
    // if (submitted) navigate('/3');
    if (submitted) switchAndCreateBrowserWallet(navigate('/3'));
  };

  return (
    <Box p={5} m={5} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <iframe
        name="to_success"
        style={{ display: 'none' }}
        onLoad={handleIframeLoad}
      />
      <form
        action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSfTLIx22NDqlwpsYl0W6046ftRIVbiW8Dta59MFqCAqnJ2v3g/formResponse"
        target="to_success"
        onSubmit={handleFormSubmit}
      >
        {/* ここで各コンポーネントを配置 */}
        <Divider my={4} />
      <FormControl id="purpose">
        <FormLabel fontWeight="bold">Q. アンケートShotはアンケート回答者にNFTを配布するサービスです。
アンケートShotのサービスについて教えてください。</FormLabel>
        <RadioGroup name="entry.404221429" onChange={setPurpose} value={purpose}>
          <Stack direction="column">
            <Radio value="利用してみたい">利用してみたい</Radio>
            <Radio value="利用したくない">利用したくない</Radio>
            <Radio value="どちらでもない">どちらでもない</Radio>
            {/* <Radio value="いらない">いらない</Radio> */}
          </Stack>
        </RadioGroup>
      </FormControl>
        {/* 他のFormControl要素 */}
        <Divider my={4} />
        <FormControl id="feedback">
        <FormLabel fontWeight="bold">Q. その他ご意見、ご要望がございましたら、教えてください。</FormLabel>
        <Textarea
          name="entry.1637959620" // Replace with the actual entry number
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="ここにご意見をお書きください。"
        />
      </FormControl>
        <SubmitButton
          walletAddress={walletAddress}
          purpose={purpose}
          informationSource={informationSource}
          satisfaction={satisfaction}
          feedback={feedback}
          
        />
      </form>
    </Box>
  );
};

export default QuestionForm;

// 修正点2023/08/20
// divider追加